import { getUserInfo } from '@/modules/Auth/services'
import useAuthStore from '@/stores/useAuthStore'
import usePermissionsStore from '@/stores/usePermissionsStore'
import authSdk, { authSdkHelpers } from '@/utils/sdk'
import { useQuery } from '@tanstack/react-query'

const useVerifyToken = () => {
    const { setEmployee } = useAuthStore()
    const {
        setPermissions,
        setIsAdmin,
        setCanFilterCustomerEventFollowers,
        setCanDeleteCustomerJourneyNote,
        setCanDeletePlainNotesOnlyCustomerJourney,
        setCanViewLeadOriginCustomers,
    } = usePermissionsStore()

    const { isLoading } = useQuery({
        queryKey: ['verify-token'],
        queryFn: async () => {
            try {
                // Pre-check and refresh token if expired to avoid 401
                await authSdkHelpers.ensureValidToken()

                const { result } = await getUserInfo()
                setEmployee(result?.employee)
                setPermissions(result?.authorization?.permissions)
                setIsAdmin(result?.is_admin ?? false)
                setCanFilterCustomerEventFollowers(
                    result?.can_filter_customer_event_followers ?? false
                )
                setCanDeleteCustomerJourneyNote(
                    result?.can_delete_customer_journey_note ?? false
                )
                setCanDeletePlainNotesOnlyCustomerJourney(
                    result?.can_delete_plain_notes_only_customer_journey ??
                        false
                )
                setCanViewLeadOriginCustomers(
                    result?.can_view_lead_origin_customers ?? false
                )
                return result
            } catch (error) {
                setEmployee(null)
                setPermissions([])
                setIsAdmin(false)
                setCanFilterCustomerEventFollowers(false)
                setCanDeleteCustomerJourneyNote(false)
                setCanDeletePlainNotesOnlyCustomerJourney(false)
                setCanViewLeadOriginCustomers(false)
                console.error('Failed to verify token:', error)
                throw error
            }
        },
        enabled: !!authSdk.getAccessToken(),
        retry: false, // SDK handles token refresh and retry internally
        staleTime: 5 * 60 * 1000, // Consider token valid for 5 minutes
        gcTime: 10 * 60 * 1000, // Keep in cache for 10 minutes
    })

    return { isLoading }
}

export default useVerifyToken
